import { StakeLogo } from "../../Assets/Images";
import { SupportChat } from "../../Assets/Icons";
import { useLogout } from "../../CustomHooks/Mutations";
import { onSignOut } from "../../Utils/helpers";
import { useIntercom } from "react-use-intercom";

function SignOutIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
      <path
        transform="matrix(1 0 0 1 10.667 4.667)"
        d="M0.000 6.667C0.000 6.667 3.333 3.333 3.333 3.333C3.333 3.333 0.000 0.000 0.000 0.000"
        stroke="#F4FDFA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        transform="matrix(1 0 0 1 6 8)"
        d="M8.000 0.000C8.000 0.000 0.000 0.000 0.000 0.000"
        stroke="#F4FDFA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        transform="matrix(1 0 0 1 2 2)"
        d="M4.000 12.000C4.000 12.000 1.333 12.000 1.333 12.000C0.980 12.000 0.641 11.860 0.391 11.609C0.140 11.359 0.000 11.020 0.000 10.667C0.000 10.667 0.000 1.333 0.000 1.333C0.000 0.980 0.140 0.641 0.391 0.391C0.641 0.140 0.980 0.000 1.333 0.000C1.333 0.000 4.000 0.000 4.000 0.000"
        stroke="#F4FDFA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function BattlecardHeader() {
  const { show: showIntercom } = useIntercom();
  const { mutate: initLogout } = useLogout({
    onSettled: onSignOut,
  });

  return (
    <div className="bc-battlecard-header" role="banner">
      <div className="bc-battlecard-header-inner">
        <StakeLogo className="bc-battlecard-header-logo" aria-label="Stake" />
        <div className="bc-battlecard-header-actions">
          <button type="button" className="bc-battlecard-header-support" onClick={showIntercom}>
            <SupportChat />
            Support
          </button>
          <button type="button" className="bc-battlecard-header-sign-out" onClick={initLogout}>
            <SignOutIcon />
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
}
